const initialState = {
    slots: [{}, {}, {}, {}, {}],
    validationError: null,
    uploadError: null,
    isUploadingWithApp: false,
    imageCount: 0
};

function validate(newState) {
    if (newState.slots.some(slot => slot.isUploading)) {
        newState.validationError = 'syi_validation_images_uploading';
    } else if (newState.slots.every(slot => !slot.imageUrl)) {
        newState.validationError = 'syi_validation_images';
    } else {
        newState.validationError = null;
    }
    return newState;
}

function resolveFirstEmpty(slots) {
    let foundFirst = false;
    for (var i = 0; i < slots.length; i++) {
        if (slots[i].imageUrl || foundFirst) {
            slots[i].firstEmpty = false;
        } else {
            slots[i].firstEmpty = true;
            foundFirst = true;
        }
    }
}

function resetUploadError(newState) {
    newState.uploadError = null;
}

function removeLastLoading(newState) {
    const slots = newState.slots;
    for (var i = slots.length; i-- > 0; ) {
        if (slots[i].isUploading) {
            slots[i].isUploading = false;
            return;
        }
    }
}

function setLoadingOnFreeSlots(newState, numberOfLoading) {
    const slots = newState.slots;
    for (var i = 0; i < slots.length; i++) {
        if (!slots[i].imageId) {
            slots[i].isUploading = true;
            if (--numberOfLoading <= 0) {
                return;
            }
        }
    }
}

function setImageCount(newState) {
    const withUrl = newState.slots.filter(slot => !!slot.imageUrl);
    newState.imageCount = withUrl.length;
}

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_DRAFT_IMAGES': {
            var slots = [{}, {}, {}, {}, {}];

            for (let i = 0; i < slots.length; i++) {
                slots[i].isListingImage = false;
                slots[i].imageId = null;
                slots[i].rotationDegrees = null;
                slots[i].imageUrl = null;
                slots[i].firstEmpty = false;
                slots[i].isUploading = false;
            }

            var images = action.payload;
            for (let i = 0; i < images.length && i < slots.length; i++) {
                if (images[i].draftImage) {
                    slots[i].isListingImage = false;
                    slots[i].imageId = images[i].draftImage.imageId;
                    slots[i].rotationDegrees =
                        images[i].draftImage.rotationDegrees;
                } else if (images[i].listingImage) {
                    slots[i].isListingImage = true;
                    slots[i].filename = images[i].listingImage.filename;
                    slots[i].imageGroupId = images[i].listingImage.imageGroupId;
                    slots[i].imageId = images[i].listingImage.imageId;
                    slots[i].rotationDegrees =
                        images[i].listingImage.rotationDegrees;
                } else {
                    slots[i].isListingImage = false;
                    slots[i].imageId = images[i].imageId;
                    slots[i].rotationDegrees = images[i].rotationDegrees;
                }
                slots[i].imageUrl = images[i].imageUrl;
            }

            resolveFirstEmpty(slots);
            let newState = { ...state, slots };
            setImageCount(newState);
            resetUploadError(newState);
            return validate(newState);
        }
        case 'SET_UPLOADED_IMAGE_IN_SLOT': {
            let newslots = [...state.slots];
            let slot = newslots[action.slotIndex];
            slot.imageUrl = action.imageUrl;
            slot.imageId = action.imageId;
            slot.isListingImage = false;
            slot.isUploading = false;
            slot.rotationDegrees = null;
            resolveFirstEmpty(newslots);
            let newState = { ...state, slots: newslots };
            setImageCount(newState);
            resetUploadError(newState);
            return validate(newState);
        }
        case 'SET_IMAGE_SLOTS': {
            let newslots = [...action.slots];
            resolveFirstEmpty(newslots);
            let newState = { ...state, slots: newslots };
            setImageCount(newState);
            resetUploadError(newState);
            return validate(newState);
        }
        case 'SET_IMAGE_ROTATION': {
            let slots = [...state.slots];
            slots[action.slotIndex].rotationDegrees = action.rotationDegrees;
            let newState = { ...state, slots: slots };
            resetUploadError(newState);
            return validate(newState);
        }
        case 'SET_IMAGE_UPLOAD_FAILED': {
            let newState = { ...state, uploadError: action.payload };
            setImageCount(newState);
            removeLastLoading(newState);
            return validate(newState);
        }
        case 'SET_IMAGES_UPLOADING': {
            let slots = [...state.slots];
            let newState = { ...state, slots: slots, uploadError: null };
            setLoadingOnFreeSlots(newState, action.numberOfSlots);
            return validate(newState);
        }
        case 'SET_MOBILE_UPLOAD': {
            const newState = {
                ...state,
                isUploadingWithApp: action.isUploadingWithApp
            };
            if (action.isUploadingWithApp) {
                resetUploadError(newState);
            }
            return newState;
        }
        case 'HIDE_ALL_ERRORS': {
            let newState = { ...state, uploadError: null };
            return newState;
        }
        default:
            return state;
    }
};
